var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showHeader)?_c('div',{staticClass:"row footer-container centered clearfix"},[_c('div',{staticClass:"container footer-navigation mobile-reorder",class:_vm.showSubMenu},[_c('rich-text-renderer',{attrs:{"data":_vm.data.fields.footerBody}})],1),_c('Footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }